<div class="card border-0 shadow-sm m-0 border-0">
  <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded-top">
    <div class="d-flex gap-2">
      <button type="button" class="badge px-3 py-2 clickable d-flex align-items-center border-0" [ngClass]="{'bg-primary text-dark': activeTab === 'announcements', 'bg-white text-dark border': activeTab !== 'announcements'}" (click)="setActiveTab('announcements')">
        <i class="fa fa-bullhorn me-1" aria-hidden="true"></i>Announcements
        @if (filterStatus === 'UnRead') {
          <span class="badge bg-warning text-dark ms-2">
            {{getUnReadAnnouncementsCount()}}
          </span>
        }
        @if (filterStatus === 'Read') {
          <span class="badge bg-warning text-dark ms-2">
            {{getReadAnnouncementsCount()}}
          </span>
        }
      </button>
      <button type="button" class="badge px-3 py-2 clickable d-flex align-items-center border-0" [ngClass]="{'bg-primary text-dark': activeTab === 'notifications', 'bg-white text-dark border': activeTab !== 'notifications'}" (click)="setActiveTab('notifications')">
        <i class="fa fa-bell me-1" aria-hidden="true"></i>Notifications
        @if (filterStatus === 'UnRead') {
          <span class="badge bg-warning text-dark ms-2">
            {{getUnReadNotificationsCount()}}
          </span>
        }
        @if (filterStatus === 'Read') {
          <span class="badge bg-warning text-dark ms-2">
            {{getReadNotificationsCount()}}
          </span>
        }
      </button>
    </div>
    <div class="d-flex gap-1">
      <button type="button" class="badge bg-white border clickable text-dark" [ngClass]="{'border-primary': filterStatus === 'UnRead'}" (click)="setFilterStatus('UnRead')">
        <i class="fa fa-eye-slash me-1" aria-hidden="true"></i>Unread
      </button>
      <button type="button" class="badge bg-white border clickable text-dark" [ngClass]="{'border-primary': filterStatus === 'Read'}" (click)="setFilterStatus('Read')">
        <i class="fa fa-check-double text-primary me-1" aria-hidden="true"></i>Read
      </button>
      <button type="button" class="badge bg-white border clickable text-dark" (click)="clearAll()">
        <i class="fa fa-check-circle me-1 text-success" aria-hidden="true"></i>Mark All as Read
      </button>
    </div>
  </div>

  <!-- Announcements -->
  @if (activeTab === 'announcements') {
    <div>
      <ul class="list-group list-group-flush">
        @for (announcement of getFilteredAnnouncements(); track announcement; let i = $index) {
          <li class="list-group-item py-1">
            <div class="d-flex justify-content-between">
              <div class="d-flex clickable" (click)="openNotification(announcement)">
                <div class="d-flex flex-column justify-content-center">
                  <i class="fa-duotone fa-bell shadow-sm align-self-center notification-icon"></i>
                </div>
                <div class="m-3">
                  <b>
                    {{announcement.announcementHeader}}
                  </b>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="ms-auto mb-1 d-flex">
                  <span class="badge bg-warning clickable" (click)="openNotification(announcement)">
                    <i class="fa-regular fa-up-right-and-down-left-from-center text-dark"></i>
                  </span>
                  <span class="badge bg-warning ms-2 clickable" (click)="deleteNotification(i)">
                    <i class="fa fa-trash-alt text-dark clickable"></i>
                  </span>
                </div>
                <div>
                  <p class="text-muted mb-0 float-end">
                    <small>
                      <small>
                        <i class="fas fa-clock"></i>
                        <span class="text-muted">
                          {{announcement.announcementUpdatedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}} - {{announcement.announcementStatus}}
                        </span>
                      </small>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  }

  <!-- Notifications -->
  @if (activeTab === 'notifications') {
    <div>
      <ul class="list-group list-group-flush">
        @for (notification of getFilteredNotifications(); track notification; let i = $index) {
          <li class="list-group-item py-1">
            <div class="d-flex justify-content-between">
              <div class="d-flex clickable" (click)="openNotification(notification)">
                <div class="d-flex flex-column justify-content-center">
                  <i class="fa-duotone fa-bell shadow-sm align-self-center notification-icon"></i>
                </div>
                <div class="m-3">
                  <b>
                    {{notification.pushNotificationHeader}}
                  </b>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="ms-auto mb-1">
                  <span class="badge bg-warning clickable" (click)="openNotification(notification)">
                    <i class="fa-regular fa-up-right-and-down-left-from-center text-dark"></i>
                  </span>
                  <span class="badge bg-warning ms-2 clickable" (click)="deleteNotification(i)">
                    <i class="fa fa-trash-alt text-dark clickable"></i>
                  </span>
                  <!-- <i class="fa-regular fa-up-right-and-down-left-from-center p-2 mx-2 shadow-sm" style="border-radius: 4px;"></i>
                  <i class="fa fa-times text-danger clickable pb-2 p-2 shadow-sm"  style="border-radius: 4px;" (click)="deleteNotification(i)"></i> -->
                </div>
                <div>
                  <p class="text-muted mb-0 float-end">
                    <small>
                      <small>
                        <i class="fas fa-clock"></i>
                        <span class="text-muted">
                          {{notification.pushNotificationUpdatedDate | date: 'MM/dd/yyyy h:mm a' : '' : 'en-US'}}
                        </span>
                      </small>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>

